import { AiOutlineEye } from "react-icons/ai";
import { BiTachometer } from "react-icons/bi";
import { BsPalette } from "react-icons/bs";
import { FaFont } from "react-icons/fa";
import { FiAirplay } from "react-icons/fi";
import { TbFileExport } from "react-icons/tb";

export const buildCloudFoundationWhatWeOffer = [
  {
    icon: FiAirplay,
    title: "Cloud Strategy Development",
    desc: "We collaborate with your team to craft a tailored cloud strategy aligned with your business objectives. Our experts assess your infrastructure, applications, and requirements to create a custom roadmap for a successful cloud adoption.",
  },
  {
    icon: AiOutlineEye,
    title: "Cloud Infrastructure Setup",
    desc: "From configuring networks to setting up virtual machines, storage, and security protocols, we ensure a seamless cloud deployment. Our meticulous approach minimizes downtime and operational disruptions, allowing you to transition smoothly.",
  },
  {
    icon: BiTachometer,
    title: "Secure Cloud",
    desc: "Security is our priority. We implement advanced security measures such as access controls, encryption, and continuous monitoring to safeguard your cloud environment and protect sensitive data.",
  },
  {
    icon: BsPalette,
    title: "Architecture and Design",
    desc: "Our skilled architects design scalable, secure cloud architectures that optimize performance while controlling costs. We follow best practices to ensure your cloud infrastructure is resilient, reliable, and ready for growth.",
  },
  {
    icon: FaFont,
    title: "Data Migration and Integration",
    desc: "We handle the complex task of migrating data and applications with precision, ensuring data integrity and minimizing risk. Our experts integrate your existing systems with cloud services, ensuring seamless collaboration and communication across your organization.",
  },
];

export const cloudMigrationWhatWeOffer = [
  {
    icon: FiAirplay,
    title: "Smooth and Successful Cloud Migration with CodeElan",
    desc: "Experience a hassle-free transition to the cloud with CodeElan’s Cloud Migration service. We specialize in delivering the benefits of scalability, flexibility, and cost-efficiency, handling the intricacies of migration efficiently. Our skilled team uses tried-and-tested methodologies to ensure a successful migration, empowering your business to leverage the cloud’s full potential without disruption.",
  },
  {
    icon: AiOutlineEye,
    title: "Thorough Cloud Evaluation",
    desc: "Our expert team at CodeElan starts with face-to-face interviews with your business and IT stakeholders to fully understand your unique needs and challenges. We conduct a detailed architectural assessment and identify key opportunities for optimizing costs and capacity. This approach ensures a well-rounded and efficient migration plan that aligns with your business goals.",
  },
  {
    icon: BiTachometer,
    title: "Mitigation strategy foundation ",
    desc: "We assist you in prioritizing the applications, processes, and infrastructure for migration crafting a strategy that meets your needs. Our comprehensive approach addresses potential risks and minimizes disruption, ensuring a smooth transition while aligning with your operational goals.",
  },
  {
    icon: BsPalette,
    title: "Platform Selection",
    desc: "Our team at CodeElan provides expert guidance in choosing the most suitable cloud platform for your business—public, private, or hybrid. We assess your regulatory and compliance needs, such as HIPAA, PCI, SOC 1 and 2, and GDPR, to ensure your platform selection meets all relevant industry standards and regulations.",
  },
];

export const kubernetWhatWeOffer = [
  {
    icon: FiAirplay,
    title: "Data Engineering & Management",
    desc: "Empower your business with seamless data collection, integration, and transformation. Our experts design and implement robust data warehousing and big data solutions, ensuring efficient cloud and on-prem data pipelines with top-tier governance and security.",
  },
  {
    icon: AiOutlineEye,
    title: "AI & Machine Learning Solutions",
    desc: "Harness the power of AI with cutting-edge predictive analytics, Computer Vision, and natural language processing. We build AI-driven chatbots and virtual assistants to enhance customer engagement while ensuring continuous monitoring and performance optimization.",
  },
  {
    icon: BiTachometer,
    title: "Business Intelligence & Analytics",
    desc: "Transform raw data into actionable insights with custom dashboards, real-time analytics, and KPI monitoring. Our decision support systems provide a strategic edge, enabling data-driven decision-making for sustained growth and efficiency.",
  },
  {
    icon: BsPalette,
    title: "Automation & Optimization",
    desc: "Streamline operations with AI-powered automation and intelligent process optimization. From supply chain enhancements to fraud detection and document processing, we deliver scalable solutions that drive efficiency and reduce manual effort.",
  },
];

// build in cloud
export const productDevWhatWeOffer = [
  {
    icon: FiAirplay,
    title: "Ideation & Conceptualization",
    desc: "Partner with our expert team to refine your ideas and conceptualize a product that aligns with your vision and market demands, setting the foundation for success.",
  },
  {
    icon: AiOutlineEye,
    title: "Full-Stack Development",
    desc: "From front-end to back-end, our full-stack development services cover every aspect of product creation, ensuring your product meets both functional and technical requirements.",
  },
  {
    icon: BiTachometer,
    title: "Quality Assurance & Testing",
    desc: "We guarantee the reliability and performance of your product through rigorous quality assurance processes, including unit, integration, and user acceptance testing.",
  },
  {
    icon: BsPalette,
    title: "Agile Development Methodology",
    desc: "Adopt an agile approach for maximum flexibility, enabling iterative improvements and rapid prototyping to speed up time-to-market without sacrificing quality.",
  },
  {
    icon: FaFont,
    title: "User-Centric Design",
    desc: "We prioritize user-centric design to create intuitive, engaging experiences that enhance usability and drive customer satisfaction.",
  },
  {
    icon: TbFileExport,
    title: "Post-Launch Support",
    desc: "Our support continues beyond the launch. We provide ongoing maintenance and updates, ensuring your product performs at its best and adapts to evolving needs.",
  },
];
export const devOpsWhatWeOffer = [
  {
    icon: FiAirplay,
    title: "Continuous Integration & Deployment",
    desc: "Accelerate software delivery by implementing automated CI/CD pipelines. This ensures frequent, reliable releases while maintaining the highest quality standards.",
  },
  {
    icon: AiOutlineEye,
    title: "Automated Testing & Quality Assurance",
    desc: "Integrate automated testing frameworks into your development pipeline to achieve comprehensive test coverage and ensure that your software meets rigorous quality benchmarks.",
  },
  {
    icon: BiTachometer,
    title: "Monitoring & Performance Optimization",
    desc: "Leverage robust monitoring and analytics tools to gain actionable insights into application performance. Identify issues early and optimize resource usage to maintain peak performance.",
  },
  {
    icon: BsPalette,
    title: "Infrastructure as Code",
    desc: "Harness infrastructure automation and configuration management tools to efficiently provision, manage, and scale your infrastructure resources, streamlining operations.",
  },
  {
    icon: FaFont,
    title: "Release Management",
    desc: "Streamline the release process with controlled deployments, rollbacks, and versioning. Ensure smooth transitions from development to production environments with minimal disruption.",
  },
  {
    icon: TbFileExport,
    title: "Collaboration & Communication",
    desc: "Promote seamless collaboration between development and operations teams. Break down silos and enable effective communication throughout the software development lifecycle for efficient, coordinated workflows.",
  },
];
export const testingAutomationWhatWeOffer = [
  {
    icon: FiAirplay,
    title: "Strategic Test Planning",
    desc: "Partner with our testing experts to develop a tailored test strategy for your application’s unique needs. We help you define clear test objectives, establish scope, and ensure comprehensive coverage to align with your goals.",
  },
  {
    icon: AiOutlineEye,
    title: "Automated Regression Testing",
    desc: "Speed up validation of your application’s functionality with automated regression testing. We ensure that code changes don’t introduce unexpected issues, keeping your software stable and reliable with every update.",
  },
  {
    icon: BiTachometer,
    title: "Performance Testing for Optimal Results",
    desc: "We assess your system's behavior under varying load conditions through detailed performance testing. Our process uncovers bottlenecks and optimizes your application’s performance for smoother, faster operations.",
  },
  {
    icon: BsPalette,
    title: "Custom Test Automation Frameworks",
    desc: "We specialize in developing bespoke test automation frameworks that streamline script creation, execution, and maintenance. By leveraging leading industry tools, we help you achieve testing efficiency that scales with your needs.",
  },
  {
    icon: FaFont,
    title: "Seamless Continuous Integration & Testing",
    desc: "By embedding testing into your continuous integration and delivery pipelines, we enable automated tests at every phase of development. This early detection helps you resolve issues before they impact your project timelines.",
  },
  {
    icon: TbFileExport,
    title: "Mobile & Cross-Browser Testing",
    desc: "Our automated mobile and cross-browser testing solutions deliver a seamless user experience across devices and browsers. We help you identify compatibility issues, ensuring consistent performance for all your users.",
  },
];
export const manageObservabilityWhatWeOffer = [
  {
    icon: FiAirplay,
    title: "Monitoring & Alerting",
    desc: "We implement advanced monitoring solutions to track critical metrics, performance indicators, and resource usage in real time. This proactive approach allows for the early detection of anomalies and rapid resolution of potential issues before they impact operations.",
  },
  {
    icon: AiOutlineEye,
    title: "Incident Management",
    desc: "Our dedicated team swiftly handles incidents, investigating and resolving issues to minimize downtime. With a focus on prompt action, we ensure your operations remain seamless and uninterrupted.",
  },
  {
    icon: BiTachometer,
    title: "Actionable Reporting & Insights",
    desc: "Gain valuable insights with our comprehensive reports and real-time dashboards. These provide clear visibility into system performance, trends, and key areas for improvement, helping stakeholders make informed decisions.",
  },
  {
    icon: BsPalette,
    title: "Log Management & Analysis",
    desc: "We centralize logs from multiple sources and perform real-time analysis to uncover essential insights into system behavior, application performance, and security events. This accelerates troubleshooting and system optimization.",
  },
  {
    icon: FaFont,
    title: "Performance Optimization",
    desc: "Using detailed observability data, we identify and resolve performance bottlenecks, optimize resource utilization, and improve the efficiency and responsiveness of your cloud systems for a superior user experience.",
  },
];
export const observabilityEngineeringWhatWeOffer = [
  {
    icon: FiAirplay,
    title: "Distributed Tracing",
    desc: "Implement distributed tracing to track and analyze requests across your microservices architecture. This enables a clear understanding of end-to-end transaction flows, helping you identify performance bottlenecks and enhance system reliability.",
  },
  {
    icon: AiOutlineEye,
    title: "Metrics Monitoring",
    desc: "Set up comprehensive metrics monitoring to collect and visualize key performance indicators. This allows you to track system health, identify trends, and make data-driven decisions for continuous improvement.",
  },
  {
    icon: BiTachometer,
    title: "Performance Optimization",
    desc: "Leverage observability data to pinpoint performance bottlenecks, optimize resource utilization, and enhance the overall efficiency and responsiveness of your cloud systems.",
  },
  {
    icon: BsPalette,
    title: "Log Analysis and Management",
    desc: "Centralize logs from multiple sources and perform in-depth analysis using advanced log management techniques. Gain valuable insights into system behavior, troubleshoot issues, and optimize performance.",
  },
  {
    icon: FaFont,
    title: "Anomaly Detection and Alerting",
    desc: "Deploy advanced anomaly detection algorithms to identify unusual patterns in your cloud environment. Generate proactive alerts that enable swift investigation and resolution of issues.",
  },
  {
    icon: TbFileExport,
    title: "Observability Strategy and Consulting",
    desc: "Our observability experts provide strategic guidance to help you define an effective observability strategy, choose the right tools, and implement best practices tailored to your specific needs.",
  },
];
export const cloudOperationWhatWeOffer = [
  {
    icon: FiAirplay,
    title: "Infrastructure Monitoring and Management",
    desc: "Proactively monitor your cloud infrastructure to ensure health, availability, and performance. We manage infrastructure provisioning, configuration, and optimization to maintain a stable and scalable environment.",
  },
  {
    icon: AiOutlineEye,
    title: "Cost Optimization",
    desc: "Maximize cloud cost-efficiency by analyzing resource utilization, rightsizing instances, and implementing cost-saving strategies. We leverage reserved and spot instances where applicable for additional savings.",
  },
  {
    icon: BiTachometer,
    title: "Incident Management",
    desc: "Our 24/7 team promptly responds to alerts, diagnoses issues, and resolves or escalates incidents to minimize downtime and ensure uninterrupted operations.",
  },
  {
    icon: BsPalette,
    title: "Architecture Review and Recommendations",
    desc: "Conduct regular architecture reviews, identify configuration drifts, and implement remediation. We also update infrastructure-as-code scripts to reflect recommended changes and maintain consistency.",
  },
  {
    icon: FaFont,
    title: "Automation and Orchestration",
    desc: "Automate routine operational tasks through cloud orchestration and infrastructure-as-code (IaC) practices, improving efficiency, reducing errors, and enabling rapid scalability.",
  },
  {
    icon: TbFileExport,
    title: "Disaster Recovery and Service Availability",
    desc: "Ensure robust disaster recovery with properly configured backups and periodic recovery tests. We regularly update recovery procedures to match the evolving environment, ensuring data can always be restored.",
  },
];
